import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import s from './TestResultReport.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ReportItem from './ReportItem';
import { WidgetVisibility } from '../../utils/widgetManager';
import Form from 'react-bootstrap/Form';

const TestResultReportItemTable = ({
  resultItems,
  testCategories,
  setShowAddEdit,
  showAddEdit,
  disableMode,
  setDisableMode,
  onAddReportItem,
  onChangeReportItem,
  userProfileWidgets,
  updateAllowed,
  formError,
  qualityReport,
  intl
}) => {
  const addNewReportItemHandler = () => {
    setShowAddEdit(true);
    setDisableMode(true);
  };

  const deleteDataHandler = (TestResultReportItemId, identifer) => {
    if (TestResultReportItemId > -1) {
      let resultItemList = [...resultItems] || [];
      resultItemList = resultItemList.map(item => {
        if (item.testCategoryTypes && item.testCategoryTypes.length > 0) {
          item.testCategoryTypes = item.testCategoryTypes.filter(type => {
            if (type.GuidIdentifier === identifer) {
              type.IsDeleted = true;
            }
            return type;
          });
        }
        if (item.testCategoryTypes.length == 0 || item.testCategoryTypes.filter(type => !type.IsDeleted).length === 0) {
          item.IsDeleted = true;
        }
        return item;
      });

      resultItemList = resultItemList.map(item => {
        item.testCategoryTypes = item.testCategoryTypes.filter(type => !type.IsDeleted || type.TestResultReportItemId);
        return item;
      });
      onChangeReportItem(resultItemList);
    }
  };

  const onCancelReportItem = () => {
    setShowAddEdit(false);
    setDisableMode(false);
  };

  const onValueChange = (e, testCategoryType) => {
    const resultItemList = [...resultItems] || [];
    resultItemList.map(item => {
      if (item.testCategoryTypes && item.testCategoryTypes.length > 0) {
        item.testCategoryTypes = item.testCategoryTypes.map(type => {
          if (type.GuidIdentifier === testCategoryType.GuidIdentifier) {
            return {
              ...type,
              [e.target.name]: e.target.value
            };
          }
          return type;
        });
      }
      return item;
    });
    onChangeReportItem(resultItemList);
  };

  const CategoryContent = (
    <ReportItem
      onAddReportItem={onAddReportItem}
      testCategories={testCategories}
      resultItems={resultItems}
      onCancelReportItem={onCancelReportItem}
      qualityReport={qualityReport}
    />
  );

  let newRowClass = showAddEdit ? s.newRow : '';

  return (
    <div>
      <div className={s.testresultContent}>
        <Row>
          <Col>
            <h4 className={s.subheading}>
              <FormattedMessage id="testResult.testResults" defaultMessage="Test Results" />
            </h4>
          </Col>
          <Col>
            <Button
              className={s.addbutton}
              style={WidgetVisibility(userProfileWidgets, 'WQSP_TESTRESULTSREPORTITEM_ADDNEW')}
              onClick={addNewReportItemHandler}
              disabled={disableMode}
            >
              + <FormattedMessage id="common.addNew" defaultMessage="ADD NEW" />
            </Button>
          </Col>
        </Row>
      </div>
      <div>
        {resultItems.map(item => {
          return (
            !item.IsDeleted && (
              <div key={item.TestCategoryId} className={s.grpItem}>
                <Row className={s.grpHeading}>
                  <Col>
                    <h4>{item.CategoryName}</h4>
                  </Col>
                </Row>

                {item.testCategoryTypes && (
                  <Table key={item.GuidIdentifier} variant className={s.innerTable}>
                    <thead>
                      <tr>
                        <th>
                          <FormattedMessage id="wqsp.common.testType" defaultMessage="Test Type" />
                        </th>
                        <th>
                          <FormattedMessage id="testResult.uOM" defaultMessage="Unit of Measure" />
                        </th>
                        <th>
                          <FormattedMessage id="testResult.value" defaultMessage="Value" />
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.testCategoryTypes.map(n => {
                        return (
                          !n.IsDeleted && (
                            <Fragment key={n.GuidIdentifier}>
                              <tr key={n.TestResultItemId} data-unittest="CategoryItemList">
                                <td>{n.Name}</td>
                                <td>{n.UnitOfMeasure}</td>
                                <td>
                                  <Form.Control
                                    type="text"
                                    name="Value"
                                    onChange={e => onValueChange(e, n)}
                                    value={n.Value || ''}
                                    className={`${s.formControlSmall} ${
                                      formError && (!n.Value || n.Value === '') ? s.formControlError : ''
                                    }`}
                                  />
                                </td>
                                <td>
                                  {updateAllowed && (
                                    <div className={s.buttonContainer}>
                                      <Button
                                        variant="outline-secondary"
                                        className={s.removeButton}
                                        href="#"
                                        onClick={deleteDataHandler.bind(this, n.TestResultReportItemId, n.GuidIdentifier)}
                                        disabled={disableMode}
                                        data-unittest="deleteData"
                                        style={WidgetVisibility(userProfileWidgets, `WQSP_TESTRESULTSREPORTITEM_DELETE`)}
                                      >
                                        <FormattedMessage id="common.remove" defaultMessage="Remove" />
                                      </Button>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            </Fragment>
                          )
                        );
                      })}
                    </tbody>
                  </Table>
                )}
              </div>
            )
          );
        })}
        {formError && (
          <div className={s.grpHeading}>
            <p role="alert" className={s.error}>
              {formError}
            </p>
          </div>
        )}
        <div className={newRowClass}>{showAddEdit && CategoryContent}</div>
      </div>
    </div>
  );
};

TestResultReportItemTable.defaultProps = {
  resultItems: {},
  testCategories: [],
  userProfileWidgets: [],
  showAddEdit: false,
  disableMode: false,
  updateAllowed: false
};

TestResultReportItemTable.propTypes = {
  setShowAddEdit: PropTypes.func.isRequired,
  setDisableMode: PropTypes.func.isRequired,
  showAddEdit: PropTypes.bool,
  onAddReportItem: PropTypes.func.isRequired,
  onChangeReportItem: PropTypes.func.isRequired,
  updateAllowed: PropTypes.bool,
  userProfileWidgets: PropTypes.object
};

export default injectIntl(TestResultReportItemTable);
